import React from "react";
import { Alert } from "@material-ui/lab";
import { useTranslation } from "react-i18next";

interface CaptureHintsProps {
  modeCardIDCapture: boolean;
  isMobileOrIpad: boolean;
}

const CaptureHints: React.FC<CaptureHintsProps> = ({ modeCardIDCapture, isMobileOrIpad }) => {
  const { t } = useTranslation(["authCapture"]);
  const captureNumber = modeCardIDCapture ? 2 : 1;

  return (
    <Alert severity="info">
      <strong>
        {`${t("captureTitle", { ns: "authCapture" })} ${captureNumber}:`}{" "}
        {isMobileOrIpad
          ? t("shotCommands.captureTips.mobile", { ns: "authCapture" })
          : t("shotCommands.captureTips.web", { ns: "authCapture" })}
      </strong>
      <br />
      <br />
      {modeCardIDCapture
        ? t("shotCommands.captureTips.capture2", { ns: "authCapture" })
        : t("shotCommands.captureTips.capture1", { ns: "authCapture" })}
    </Alert>
  );
};

export default CaptureHints;
